/** Decode admin id from JWT stored at login. */
export function getAdminIdFromToken() {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.AdminId ?? payload.adminId ?? localStorage.getItem("adminId") ?? null;
  } catch {
    return localStorage.getItem("adminId");
  }
}

export function storeAdminSession(token, adminId = null) {
  localStorage.setItem("accessToken", token);
  if (adminId != null) {
    localStorage.setItem("adminId", String(adminId));
    return;
  }
  try {
    const payload = JSON.parse(
      atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
    );
    const id = payload.AdminId ?? payload.adminId;
    if (id != null) {
      localStorage.setItem("adminId", String(id));
    }
  } catch {
    // ignore decode errors
  }
}

export function clearAdminSession() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("adminId");
}
